<template>
    <div class="lead-form-modal tw-px-4 tw-py-4">
        <div class="tw-flex tw-items-center tw-justify-between tw-mb-2">
            <div>
                <h2 v-if="title" class="tw-text-xl tw-text-black tw-font-bold">
                    {{ title }}
                </h2>
            </div>
            <dk-button class="tw-bg-transparent hover:tw-bg-transparent" is-icon-only="true" @click="hideModal()">
                <icon name="generic-close--big" size="xs" color="grey-600" />
            </dk-button>
        </div>
        <car-image :active-color="activeColor" :default-image="defaultImage" />
        <template v-if="colors && colors.length">
            <color-selection :colors="colors" :color-image="colorImage" @color-select="onColorSelect" />
        </template>
        <div class="tw-mt-4 tw-pt-4 tw-border-t tw-border-slate-100 tw-border-solid">
            <p class="tw-text-black tw-mb-4">
                {{ $t('single-guide.leadform-find-out-the-price') }}
            </p>
            <lead-form-wrapper ref="leadFormWrapper" :form-id="formId" :form-data="formData" />
        </div>
    </div>
</template>
<script>
import { dkModalAware } from '@v4/common/components/mixins/modal';

/**
 * LeadFormModal component.
 *
 * @version 4.0.0
 */
export default {
    name: 'LeadFormModal',
    components: {
        LeadFormWrapper: () => ({
            component: import(
                /* webpackChunkName: "LeadFormWrapper-vue" */ '@v4/common/components/organisms/LeadFormWrapper/LeadFormWrapper'
            ),
        }),
        Icon: () => ({
            component: import(/* webpackChunkName: "Icon-vue" */ '@v4/common/components/atoms/Icon'),
        }),
        ColorSelection: () => ({
            component: import(
                /* webpackChunkName: "ColorSelection-vue" */ '@v4/single-guide/components/molecules/ColorSelection'
            ),
        }),
        CarImage: () => ({
            component: import(/* webpackChunkName: "CarImage-vue" */ '@v4/single-guide/components/atoms/CarImage'),
        }),
        DkButton: () => ({
            component: import(/* webpackChunkName: "DkButton-vue" */ '@v4/common/components/atoms/DkButton.vue'),
        }),
    },
    mixins: [dkModalAware],
    props: {
        /**
         * Form ID.
         */
        formId: {
            type: String,
            default: '',
        },
        /**
         * Form data to send to HTTP request.
         */
        formData: {
            type: Object,
            default: null,
        },
        /**
         * Form title
         */
        title: {
            type: String,
            default: '',
        },
        /**
         * Default image
         */
        defaultImage: {
            type: String,
            default: '',
        },
        /**
         * Function that is called when a color is selected
         */
        handleColorSelect: {
            type: Function,
            default: null,
        },
        /**
         * Function that is called to fetch the car configuration
         */
        fetchCarConfiguration: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            colorImage: '',
            colors: [],
            activeColor: null,
        };
    },
    async mounted() {
        if (this.fetchCarConfiguration && typeof this.fetchCarConfiguration === 'function') {
            this.colors = await this.fetchCarConfiguration();
        }
    },
    methods: {
        onColorSelect(payload) {
            if (this.handleColorSelect && typeof this.handleColorSelect === 'function') {
                this.activeColor = this.handleColorSelect(payload);
            }
        },
    },
};
</script>

<style lang="scss" src="@v4/single-guide/components/organisms/LeadFormModal/_index.scss"></style>
